/**
 * What works with which AI tool — the same table as docs/compatibility.md, checked against each
 * tool's documentation in September 2026. "Works" is shipped and tested; "Possible" is supported by
 * the tool's documented hooks, with the Vephus adapter still to write; "Not possible" means the
 * tool offers no way to do it today.
 */

import { useI18n } from '../lib/i18n'

type Support = 'built' | 'possible' | 'none'

const TOOLS = ['Claude Code', 'Codex CLI', 'Cursor', 'Gemini CLI', 'Kiro', 'OpenCode', 'MCP'] as const

const ROWS: Array<{ key: string; support: Support[] }> = [
  { key: 'observability', support: ['built', 'built', 'built', 'built', 'built', 'built', 'built'] },
  { key: 'docs', support: ['built', 'built', 'built', 'built', 'built', 'built', 'built'] },
  { key: 'bugs', support: ['built', 'built', 'built', 'built', 'built', 'built', 'built'] },
  { key: 'prompts', support: ['built', 'possible', 'possible', 'possible', 'possible', 'possible', 'none'] },
  { key: 'heartbeat', support: ['built', 'possible', 'possible', 'possible', 'possible', 'possible', 'none'] },
  { key: 'remote', support: ['built', 'possible', 'possible', 'possible', 'none', 'possible', 'none'] },
]

export function CompatibilityMatrix() {
  const { t } = useI18n()

  return (
    <div className="stack stack--tight">
      <p className="small secondary">{t('compat.intro')}</p>
      <div className="compat">
        <table className="table compat__table">
          <thead>
            <tr>
              <th scope="col">{t('compat.feature')}</th>
              {TOOLS.map((tool) => (
                <th key={tool} scope="col">
                  {tool === 'MCP' ? t('compat.otherMcp') : tool}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row) => (
              <tr key={row.key}>
                <th scope="row">{t(`compat.row.${row.key}`)}</th>
                {row.support.map((support, index) => (
                  <td key={TOOLS[index]}>
                    <span className={`compat__cell compat__cell--${support}`}>{t(`compat.support.${support}`)}</span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="tiny muted">{t('compat.note')}</p>
    </div>
  )
}
